import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT, Location } from '@angular/common';
import { Router } from '@angular/router';
import { LANGUAGES } from './languages';

const STORAGE_KEY = 'fran-lang';
const DEFAULT_LANG = 'en';
const SUPPORTED_LANGS = LANGUAGES.map((l) => l.code);

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translateService = inject(TranslateService);
  private document = inject<Document>(DOCUMENT);
  private router = inject(Router);
  private location = inject(Location);

  readonly currentLang = this.translateService.currentLang;

  constructor() {
    this.initLanguage();
  }

  private initLanguage(): void {
    const storedLang = localStorage.getItem(STORAGE_KEY);
    const lang = storedLang ?? DEFAULT_LANG;

    this.translateService.setFallbackLang(DEFAULT_LANG);
    this.translateService.addLangs(SUPPORTED_LANGS);
    this.translateService.use(lang);

    this.translateService.onLangChange.subscribe((event) => {
      this.document.documentElement.lang = event.lang;
    });

    const current = this.translateService.getCurrentLang();
    if (current) {
      this.document.documentElement.lang = current;
    }
  }

  switchLanguage(lang: string): void {
    if (!SUPPORTED_LANGS.includes(lang)) {
      return;
    }

    this.translateService.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    this.document.documentElement.lang = lang;

    const oldLang = this.translateService.getCurrentLang();
    if (oldLang && oldLang !== lang) {
      const currentUrl = this.router.url;
      const newUrl = currentUrl.replace(`/${oldLang}`, `/${lang}`);
      if (newUrl !== currentUrl) {
        this.location.go(newUrl);
      }
    }
  }
}
